import {PANELMANAGER_SHOW_CONFIRMCLOSEDIALOG} from '../../constants';

export type ShowConfirmCloseDialogAction = {
    type : typeof PANELMANAGER_SHOW_CONFIRMCLOSEDIALOG;
    panelKey : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {ShowConfirmCloseDialogAction}
 */
const showConfirmCloseDialog = ( panelKey : string ) : ShowConfirmCloseDialogAction => {
    return {
        type: PANELMANAGER_SHOW_CONFIRMCLOSEDIALOG,
        panelKey
    };
};
export type ShowConfirmCloseDialog = typeof showConfirmCloseDialog;

export default showConfirmCloseDialog;
